import { pxToDP } from '@capsicum/common';
import { MarketingBannerCarousel } from '@capsicum/features/feeds/web';
import styled, { useTheme } from 'styled-components';

export const NCWalletMarketingBanner = () => {
	const {
		spacings: { small }
	} = useTheme();

	return (
		<S.MarketingBannerContainer>
			<MarketingBannerCarousel page="wallet" pageHorizontalSpacing={pxToDP(small)} />
		</S.MarketingBannerContainer>
	);
};

namespace S {
	export const MarketingBannerContainer = styled.div`
		margin: ${({ theme }) => theme.spacings.small} ${({ theme }) => theme.spacings.small} 0;
	`;
}
